export default __webpack_public_path__ + "static/media/alIcon.fa40fcaa.svg";